import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadOffice = () => {
  const promiseOffice = new Promise((resolve, reject) => {
    loader.load(
      "office/model/office5/office.gltf",
      function (office) {
        scene.add(office.scene);
        office.scene.traverse(function (object) {
          if (object.isMesh) {
            object.castShadow = true;
            object.receiveShadow = true;
            
            // Applichiamo il trucco del BackSide per le ombre: elimina l'acne sulla faccia visibile
            if (object.material) {
                object.material.shadowSide = THREE.BackSide;
                object.material.polygonOffset = true;
                object.material.polygonOffsetFactor = 1;
                object.material.polygonOffsetUnits = 1;
            }
          }
        });

        resolve(office);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
  });
  return promiseOffice;
};

export { loadOffice };
